import React from 'react';
import './LanguagePicker.scss';
import { getCurrentLanguage, setCurrentLanguage } from '../utils/langUtils';
import Button from './Button';

export default function LanguagePicker() {
    const currentLanguage = getCurrentLanguage();

    return (
        <div className="languagePicker">
            <Button fullSize={false} selected={currentLanguage === 'en'} onClick={() => setCurrentLanguage('en')}>
                <img className="icon" alt="Estrela" src="../../assets/us_flag.png" />
            </Button>
            <Button fullSize={false} selected={currentLanguage === 'pt'} onClick={() => setCurrentLanguage('pt')}>
                <img className="icon" alt="Estrela" src="../../assets/br_flag.png" />
            </Button>
        </div>
    );
}
